<template>
	<div class="container">
		<div class="title">
			您是哪种设备？
		</div>
		<div class="watchbox" @click="tobind" style="margin-top: 31px;">
			<img class="watchImg" width="45" height="59" src="../assets/images/watch1.png" />
			<div class="centerbox">
				<h4>4G智能情绪手表</h4>
				<p>可插SIM卡，通过IMEI连接</p>
			</div>
			<img class="iconImg" width="24" height="24" src="../assets/images/chevron-right.png" />
		</div>
		<div class="watchbox" @click="tomp" style="margin-top: 16px;">
			<img class="watchImg" width="45" height="59" src="../assets/images/watch2.png" />
			<div class="centerbox">
				<h4>蓝牙智能情绪手表</h4>
				<p>无SIM卡，通过蓝牙连接</p>
			</div>
			<img class="iconImg" width="24" height="24" src="../assets/images/chevron-right.png" />
		</div>
		<div class="unbind" @click="tobock">
			暂不绑定
		</div>
	</div>
</template>
<script>
	import {
		Button,
		Toast
	} from 'vant';
	import wx from "weixin-js-sdk";
	import {
		unbind_imei,user_info
	} from "../api/my.js"
	export default {
		props: {},
		components: {
			[Button.name]: Button,
		},
		data() {
			return {
				imei: '',
				loginPhone: '',
				modal: false,
			};
		},
		created() {},
		mounted() {
			// alert('mounted')
			let phone = localStorage.getItem('phone') || ''
			if(!phone) return this.$toast('error!')
			user_info(phone).then(res => {
				if (res.status == 200) {
					if (res.data.userinfo.nickname) {
						localStorage.setItem('nickname',res.data.userinfo.nickname)
					}
					if (res.data.userinfo.imei != '') {
						localStorage.setItem('imei',this.imei)
						this.$router.replace({
							path: '/my'
						})
					}
				}
			})
		},
		methods: {
			tomp() {
				let phone = localStorage.getItem('phone') || ''
				// let imei = localStorage.getItem('imei') || ''
				// this.$toast(phone+'-'+imei)
				// if(phone){
				// unbind_imei(phone, imei).then(res => {
				// 	if (res.status == 200) {
				// 		localStorage.removeItem('imei')
				// 	}
				// })
				// uni.$u.http.post('https://www.qingxusuanfa.com:3366/client/unbind_imei', {imei,phone}).then(res=>{
				// 	console.log(res);
				// })
				// }
				// setTimeout(()=>{
				wx.miniProgram.navigateTo({
					url: '/pages/bluetooth/bluetooth?phone=' + phone
				})
				// },800)
			},
			tobind() {
				this.$router.push({
					path: '/bind-equipment'
				})
			},
			tobock() {
				this.$router.replace({
					path: '/'
				})
			}
		},

	};
</script>

<style scoped lang="less">
	.container {
		padding: 0 16px;
		min-height: calc(100vh - 32px);
		background: linear-gradient(137deg, #E7FEFF 0%, #FFFFFF 100%);
	}

	.title {
		// height: 60px;
		// width: 100%;
		font-size: 30px;
		margin-top: 27px;
		// font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #040404;
		line-height: 18px;
		height: 18px;
		// -webkit-background-clip: text;
		// -webkit-text-fill-color: transparent;
	}

	.watchbox {
		width: 343px;
		height: 128px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.03);
		border-radius: 16px 16px 16px 16px;
		opacity: 1;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	.watchImg{
		margin-left: 25px;
	}
	.iconImg{
		margin-right: 9px;
	}
	.unbind {
		width: 56px;
		height: 18px;
		font-size: 14px;
		font-weight: 500;
		color: #B3B3B3;
		line-height: 18px;
		margin: 50px auto;
	}

	.centerbox {
		width: 200px;
		margin: 0 auto;
	}

	.centerbox h4 {
		font-size: 16px;
		font-weight: bold;
		color: #2E2E2E;
		line-height: 18px;
	}

	.centerbox p {
		margin-top: 20px;
		font-size: 14px;
		font-weight: 500;
		color: #969696;
		line-height: 18px;
	}

	// .watchbox img{
	// 	position: relative;
	// 	left: 10px;
	// }
</style>
